import { interval as observableInterval, Observable, Subscription, throwError } from 'rxjs';

import { catchError, map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';

import { SessionTokenService } from './session-token';
import { Injectable } from '@angular/core';
import { HttpCacheClient } from '../../shared/http/cache-client';
import { TimezoneStorage } from '../../shared/misc/service/timezone-storage';


@Injectable()
export class SessionManager {

  private subscription: Subscription;

  constructor(private sessionToken: SessionTokenService,
              private httpClient: HttpClient,
              private httpCacheClient: HttpCacheClient,
              private router: Router) {
  }

  public getIdentity(ttl: number = 1000): Observable<any> {
    return this.httpCacheClient.get<any>('/session', {}, ttl).pipe(
      map(
        (response: any) => {
          // if (response && response.customer && response.customer.status === 'inactive') {
          //   this.router.navigate([ '/setup' ]);
          // }
          return response;
        }),
      // catchError((error: any) => {
      //   if (error.status === 401) {
      //     if (this.subscription) {
      //       this.subscription.unsubscribe();
      //     }
      //     const route = this.router.config.find(f => f.path == this.router.url.substr(1));
      //     if (route && route.canActivate) {
      //       this.sessionToken.destroy();
      //     }
      //   }
      //   return throwError(error);
      // })
    );
  }

  public refreshToken(): Observable<any> {
    const refreshToken = this.sessionToken.getToken().refreshToken;
    return this.httpClient.patch('/session', {
      refreshToken
    });
  }

  public start() {
  }

  public destroy() {
    const isAdmin = !!this.sessionToken.getAdminToken().token;
    this.sessionToken.destroy();
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (!isAdmin && environment.logoutUrl) {
      window.location.href = environment.logoutUrl;
    } else {
      this.router.navigate(['/login']);
    }
  }
}
